var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoShareFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico_facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 25 25 25 25 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_facebook",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(-1.000000, -0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5803,2.5753 C12.9113,2.5753 11.5603,3.0463 10.5673,3.9753 C9.5453,4.9313 9.0273,6.2433 9.0273,7.8743 L9.0273,9.2143 L8.9943,9.2143 L7.4943,9.2143 L7.4943,10.7143 L7.4943,12.9993 L7.4943,14.4993 L8.9943,14.4993 L9.0273,14.4993 L9.0273,20.9773 L9.0273,22.4773 L10.5273,22.4773 L13.8283,22.4773 L15.3283,22.4773 L15.3283,20.9773 L15.3283,14.4993 L15.8893,14.4993 L17.3893,14.4993 L17.3893,12.9993 L17.3893,10.7143 L17.3893,9.2143 L15.8893,9.2143 L15.3283,9.2143 L15.3283,8.1143 C15.4663,8.1203 15.6123,8.1363 15.6333,8.1383 L17.3143,8.3363 L17.3103,6.6433 L17.3013,4.2213 L17.2963,3.0483 L16.1563,2.7703 C15.4743,2.6033 15.1643,2.5753 14.5803,2.5753 M14.5803,4.0753 C15.0493,4.0753 15.2413,4.0903 15.8013,4.2273 L15.8103,6.6493 C15.8103,6.6493 15.5963,6.6233 15.3223,6.6143 C14.3263,6.6143 13.8283,7.0443 13.8283,7.9033 L13.8283,10.7143 L15.8893,10.7143 L15.8893,12.9993 L13.8283,12.9993 L13.8283,20.9773 L10.5273,20.9773 L10.5273,12.9993 L8.9943,12.9993 L8.9943,10.7143 L10.5273,10.7143 L10.5273,7.8743 C10.5273,6.6693 10.8823,5.7353 11.5923,5.0713 C12.3023,4.4073 13.2983,4.0753 14.5803,4.0753",
    id: "Fill-1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoShareFacebook);
export default __webpack_public_path__ + "static/media/ico_share_facebook.23a000fa1d6ca97487b640a64a7cfcdf.svg";
export { ForwardRef as ReactComponent };